
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/2023-08-26-scroll-ux",
      function () {
        return require("private-next-pages/blogs/2023-08-26-scroll-ux/index.page.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogs/2023-08-26-scroll-ux"])
      });
    }
  